import React from 'react';
import { motion } from 'framer-motion';
import * as styles from '../step-intent.style';
import { Avatar } from '../../../../shared';
import { OverallStarRating } from '../../../../shared/recommendations/types';
import AverageStarRatingAndTotal, {
  STAR_RATING_SECTION,
} from '../../../../shared/average-star-rating-and-total';
import useIsDesktop from '../../../../../hooks/use-is-desktop';

type IntentHeadingProps = {
  avatarUrl: string;
  name: string;
  overallStarRating?: OverallStarRating;
};

function IntentHeading({
  avatarUrl,
  name,
  overallStarRating,
}: IntentHeadingProps): JSX.Element {
  const isDesktop = useIsDesktop();

  return (
    <>
      <motion.div layoutId="avatar" css={styles.avatarHolder}>
        <Avatar imageTitle={name} imageUrl={avatarUrl} css={styles.avatar} />
      </motion.div>

      {overallStarRating && Boolean(overallStarRating.totalReviews) && (
        <AverageStarRatingAndTotal
          section={STAR_RATING_SECTION.SIDEBAR}
          averageRating={overallStarRating.rating}
          totalReviews={overallStarRating.totalReviews}
          scrollTo={!isDesktop}
        />
      )}

      <h3 css={styles.title}>Contact {name}</h3>
    </>
  );
}

export { IntentHeading };
